export default __webpack_public_path__ + "static/media/provider-hero.626727b9.png";